
const WILLEM = '7e37aa5e-6144-493f-826f-5cc7e35b8755';
const ROMAIN = '3a097dae-31af-11e3-a74d-040108962301';
const AREE = '0b68b63c-434d-4405-ae49-46161eac7aa8';
const PIYAPORN = '3a09ad7d-31af-11e3-a74d-040108962301';

export default {
  debug: {
    becomeWillem: function() {
      //host and guest
      this.flux.actions.auth.becomeUser(WILLEM);
    },
    becomePiyaporn: function() {
      //host with a LOT of trips
      this.flux.actions.auth.becomeUser(PIYAPORN);
    },
    becomeRomain: function() {
      //is a host and ambassador
      this.flux.actions.auth.becomeUser(ROMAIN);
    },
    becomeAree: function() {
      //is a a good test organizer
      this.flux.actions.auth.becomeUser(AREE);
    },
  },
};
